import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e07aa66"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 3,
  class: "videotoolbar"
}
const _hoisted_3 = { class: "toolbar clearfix" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "clearfix" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "shownum" }
const _hoisted_9 = { style: {"height":"45px"} }
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_slider = _resolveComponent("a-slider")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["jfplayer", {'fullscreen': _ctx.isFullScreen}])
  }, [
    (_ctx.videoInfo.format === 'flv')
      ? (_openBlock(), _createElementBlock("video", {
          key: 'flv-' + _ctx.url,
          playsinline: "",
          preload: "metadata",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.togglePlay && _ctx.togglePlay(...args)))
        }))
      : (_ctx.isHls)
        ? (_openBlock(), _createElementBlock("video", {
            key: 'hls-' + _ctx.url,
            playsinline: "",
            preload: "metadata",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.togglePlay && _ctx.togglePlay(...args)))
          }))
        : (_openBlock(), _createElementBlock("video", {
            key: 'mp4-' + _ctx.url,
            onLoad: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.loadvideo && _ctx.loadvideo(...args))),
            playsinline: "",
            preload: "metadata",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.togglePlay && _ctx.togglePlay(...args)))
          }, [
            _createElementVNode("source", {
              src: _ctx.url,
              type: "video/mp4"
            }, null, 8, _hoisted_1)
          ], 32)),
    (_ctx.url)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(), _createBlock(_component_a_slider, {
            key: _ctx.url,
            class: "playpercent",
            value: _ctx.percent,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.percent) = $event)),
            step: 0.01,
            tipFormatter: null,
            onChange: _ctx.changepercent
          }, null, 8, ["value", "step", "onChange"])),
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("img", {
              class: "toolicon",
              src: require('@/assets/jfschool/images/zt.svg'),
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.pause && _ctx.pause(...args))),
              alt: ""
            }, null, 8, _hoisted_4), [
              [_vShow, _ctx.isplay]
            ]),
            _withDirectives(_createElementVNode("img", {
              class: "toolicon playicon",
              src: require('@/assets/jfschool/images/bf.svg'),
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.play && _ctx.play(...args))),
              alt: ""
            }, null, 8, _hoisted_5), [
              [_vShow, !_ctx.isplay]
            ]),
            _createElementVNode("span", null, _toDisplayString(_ctx.progress) + " / " + _toDisplayString(_ctx.formatTime(_ctx.videoInfo.duration)), 1),
            _createElementVNode("section", _hoisted_6, [
              _createVNode(_component_a_dropdown, {
                placement: 'topCenter',
                overlayClassName: 'playerTool',
                getPopupContainer: _ctx.getContainer
              }, {
                overlay: _withCtx(() => [
                  _createVNode(_component_a_menu, { onClick: _ctx.changeRate }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.speed, (item) => {
                        return (_openBlock(), _createBlock(_component_a_menu_item, {
                          key: item,
                          class: _normalizeClass({'active': _ctx.currenRate === item})
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item + 'x'), 1)
                          ]),
                          _: 2
                        }, 1032, ["class"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    class: "ant-dropdown-link toolicon",
                    onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"]))
                  }, _toDisplayString(_ctx.currenRate === 1 ? '倍速' : _ctx.currenRate + 'x'), 1)
                ]),
                _: 1
              }, 8, ["getPopupContainer"]),
              (_ctx.definitionList && _ctx.definitionList.length)
                ? (_openBlock(), _createBlock(_component_a_dropdown, {
                    key: 0,
                    placement: 'topCenter',
                    overlayClassName: 'playerTool',
                    getPopupContainer: _ctx.getContainer
                  }, {
                    overlay: _withCtx(() => [
                      _createVNode(_component_a_menu, { onClick: _ctx.changeDefinition }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.definitionList, (item) => {
                            return (_openBlock(), _createBlock(_component_a_menu_item, {
                              key: item.definitionType,
                              class: _normalizeClass({'active': _ctx.videoInfo.definitionType === item.definitionType})
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.definitionName), 1)
                              ]),
                              _: 2
                            }, 1032, ["class"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        class: "ant-dropdown-link toolicon",
                        onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"]))
                      }, _toDisplayString(_ctx.videoInfo.definitionName || '高清'), 1)
                    ]),
                    _: 1
                  }, 8, ["getPopupContainer"]))
                : _createCommentVNode("", true),
              _createVNode(_component_a_dropdown, {
                placement: 'topCenter',
                overlayClassName: 'playerTool',
                getPopupContainer: _ctx.getContainer
              }, {
                overlay: _withCtx(() => [
                  _createVNode(_component_a_menu, { style: {"height":"100px","padding":"12px"} }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.slideNum), 1),
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_a_slider, {
                          vertical: "",
                          value: _ctx.slideNum,
                          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.slideNum) = $event)),
                          tipFormatter: null,
                          onChange: _ctx.changevolume
                        }, null, 8, ["value", "onChange"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    class: "toolicon",
                    src: require('@/assets/jfschool/images/yl.svg'),
                    alt: ""
                  }, null, 8, _hoisted_7)
                ]),
                _: 1
              }, 8, ["getPopupContainer"]),
              _createElementVNode("span", null, [
                (_ctx.isFullScreen)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "toolicon",
                      src: require('@/assets/jfschool/images/qxqp.svg'),
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.exitFullscreen && _ctx.exitFullscreen(...args))),
                      alt: ""
                    }, null, 8, _hoisted_10))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      class: "toolicon",
                      src: require('@/assets/jfschool/images/qp.svg'),
                      onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.FullScreen && _ctx.FullScreen(...args))),
                      alt: ""
                    }, null, 8, _hoisted_11))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}